import { Table } from 'antd';
import { useState,useEffect } from 'react';
import useHttpClient from 'shared/hooks/http-hook';

export default function Report({ endPoint, nestedColumns, source}) {
  const showTotal = (total) => `Σύνολο: ${total}`
  const DEFAULT_PAGESIZE = 10
  const DEFAULT_CURRENT = 1
  const [pagination, setPagination] = useState({ current: DEFAULT_CURRENT, pageSize: DEFAULT_PAGESIZE, showTotal });
  const { responseData, sendRequest, status, loading } = useHttpClient();
  useEffect(() => {
        if (endPoint) {
        sendRequest({
            endpoint: endPoint?.concat(`&items=${DEFAULT_PAGESIZE}&page=${DEFAULT_CURRENT}`),
            method: 'GET',
        })
        }
    }, [endPoint, sendRequest])

    useEffect(() => {
        if (responseData && (status === 'resolved' || status === 'rejected')) {
            setPagination({ ...pagination, current: responseData?.pageIndex, total: responseData?.totalCount })
        }
    }, [status, responseData?.pageIndex, responseData?.totalCount])

    const handleTableChange = (filters) => {
        setPagination({ ...pagination, current: filters.current, pageSize: filters.pageSize })
        sendRequest({
            endpoint: endPoint?.concat(`&items=${filters.pageSize}&page=${filters.current}`),
            method: 'GET',
        })
    }

    const expandedRowRender = (record) => 
         <Table columns={nestedColumns} dataSource={source === 'heartbeat'? record.mobileDevices: record.permissionNames} pagination={false} />;
    
        
    const columns = [
        {
            title: 'policyNumber',
            key: 'policyNumber',
            dataIndex: 'policyNumber',
        },
        {
            title: 'Device Imei',
            key: 'deviceImei',
            dataIndex: 'deviceImei',
        },
    ]
    return <Table
    loading={loading}
    columns={columns}
    pagination={pagination}
    expandable={{expandedRowRender}}
    dataSource={responseData?.items.map(obj=> ({...obj, key: obj.policyNumber}))}
    onChange={handleTableChange}
  />
}